import React, { useCallback, useState } from 'react';
import moment from 'moment/moment';
import { lang, objectToSelectList, remCss, scssVariables as variables } from 'src/helpers';
import {
  CheckboxesField,
  MCButton,
  MCError,
  TimePickerField,
  ToggleSwitch,
  View
} from '../../basic';
import SVGIcon, { BASE_ICONS } from '../../svg';
import LANG_CONST from 'src/helpers/lang/const';
import { EditDay } from './EditDay';
import { generateSlots } from '../utils';

export const WorkingDays = ({ days, setDays, invalid = {}, hospital, duration, setInvalid }) => {
  const [editDayIndex, setEditDayIndex] = useState(-1);
  const handleChange = useCallback(
    (dayIndex, key, value) => {
      const old = JSON.parse(JSON.stringify(days));
      old[dayIndex][key] = value;
      setDays(old);
    },
    [days, setDays]
  );

  const handleTimesChange = useCallback(
    (dayIndex, itemIndex, newData, genSlot = false) => {
      const old = JSON.parse(JSON.stringify(days));
      for (let key in newData) old[dayIndex].times[itemIndex][key] = newData[key];
      if (genSlot)
        old[dayIndex].times[itemIndex].slots = generateSlots(
          moment(old[dayIndex].times[itemIndex].startTime),
          moment(old[dayIndex].times[itemIndex].endTime),
          duration
        );
      setDays(old);
    },
    [days, setDays, duration]
  );

  const addTime = useCallback(
    (dayIndex) => {
      const old = JSON.parse(JSON.stringify(days));
      const previousTime = old[dayIndex].times[old[dayIndex].times.length - 1];
      const startTime = previousTime.endTime;
      let endTime;
      if (startTime) {
        endTime = moment(startTime).add(3, 'h').valueOf();
      }

      old[dayIndex].times.push({
        ...previousTime,
        startTime,
        endTime,
        slots: generateSlots(moment(startTime), moment(endTime), duration)
      });
      setDays(old);
    },
    [days, setDays, duration]
  );

  const delTime = useCallback(
    (dayIndex, timeIndex) => {
      const old = JSON.parse(JSON.stringify(days));
      old[dayIndex].times = old[dayIndex].times.filter((t, i) => i !== timeIndex);
      setDays(old);
    },
    [days, setDays]
  );

  let onlyOneTime = true;

  if (onlyOneTime) {
    return (
      <>
        <div className='mc-modal-body mc-flex-col' style={{ flex: 1, gap: remCss(30) }}>
          {days.map((data, dayIndex) => {
            const { enabled, times, label, id } = data;
            const timeIndex = 0;
            const time = times[timeIndex];

            return (
              <div className={'mc-flex-20-col mc-radius-5 mc-p20 mc-b2'} key={dayIndex}>
                <div className={'mc-grow mc-flex-20 mc-pointer'}>
                  <ToggleSwitch
                    checked={enabled}
                    onChange={() => handleChange(dayIndex, 'enabled', !enabled)}
                  />
                  <div
                    onClick={() => handleChange(dayIndex, 'enabled', !enabled)}
                    className={'mc-value-418'}
                  >
                    {lang.t(label)}
                  </div>
                  {enabled && (
                    <div className={'mc-grow mc-flex-20'} style={{ justifyContent: 'flex-end' }}>
                      <div
                        className={'mc-grow'}
                        style={{ minWidth: remCss(100), maxWidth: remCss(200) }}
                      >
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          duration={30}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.startTime && moment(time.startTime)}
                          onSelect={(value) =>
                            handleTimesChange(
                              dayIndex,
                              timeIndex,
                              { startTime: value.valueOf() },
                              true
                            )
                          }
                        />
                      </div>
                      <div className={'mc-value-418'}>{lang.t('To')}</div>
                      <div
                        className={'mc-grow'}
                        style={{ minWidth: remCss(100), maxWidth: remCss(200) }}
                      >
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          duration={30}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.endTime && moment(time.endTime)}
                          onSelect={(value) =>
                            handleTimesChange(
                              dayIndex,
                              timeIndex,
                              { endTime: value.valueOf() },
                              true
                            )
                          }
                        />
                      </div>
                      <MCButton
                        onClick={() => {
                          setEditDayIndex(dayIndex);
                        }}
                        medium
                        primary
                        light
                        radius
                        style={{
                          paddingLeft: remCss(10),
                          paddingRight: remCss(5),
                          paddingVertical: remCss(5)
                        }}
                      >
                        <span>{lang.t(LANG_CONST.buttons.edit)}</span>
                        <span style={{ height: remCss(30) }}>
                          <SVGIcon
                            iconname={BASE_ICONS.DOWN}
                            width={30}
                            padding={1}
                            fill={variables['colors-mc-primary']}
                          />
                        </span>
                      </MCButton>
                    </div>
                  )}
                </div>
                <div className={'mc-flex-20 ' + (enabled ? '' : 'mc-hide')}>
                  <div className={'mc-grow'}>
                    {invalid[id + '_' + timeIndex + '_time'] && (
                      <MCError
                        error={invalid[id + '_' + timeIndex + '_time']}
                        label={LANG_CONST.time}
                        mcTextProps={{ primary: true, style: { marginTop: remCss(10) } }}
                      />
                    )}
                    {invalid[id] && (
                      <MCError
                        error={invalid[id]}
                        mcTextProps={{ primary: true, style: { textAlign: 'center' } }}
                      />
                    )}
                  </div>
                  <CheckboxesField
                    template={'2'}
                    list={objectToSelectList(LANG_CONST.constants.appointment_types)}
                    disabledList={
                      hospital ? [] : Object.keys(LANG_CONST.constants.appointment_types)
                    }
                    data={time.types}
                    onChange={(value) => {
                      if (!value.length) return;
                      handleTimesChange(dayIndex, timeIndex, { types: value });
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
        {editDayIndex > -1 && (
          <EditDay
            hide={() => setEditDayIndex(-1)}
            day={days[editDayIndex]}
            saveTimes={(times) => handleChange(editDayIndex, 'times', times)}
          />
        )}
      </>
    );
  }

  return (
    <>
      <div className='mc-modal-body mc-flex-col' style={{ flex: 1, gap: remCss(30) }}>
        {days.map((data, dayIndex) => {
          const { enabled, times, label, id } = data;

          return (
            <div className={'mc-flex-col mc-radius-5 mc-p20 mc-b2'} key={dayIndex}>
              <div className={'mc-grow mc-flex-20 mc-pointer'}>
                <ToggleSwitch
                  checked={enabled}
                  onChange={() => handleChange(dayIndex, 'enabled', !enabled)}
                />
                <div
                  onClick={() => handleChange(dayIndex, 'enabled', !enabled)}
                  className={'mc-value-418'}
                >
                  {lang.t(label)}
                </div>
                {enabled && (
                  <div className={'mc-grow mc-flex-col mc-flex-end'}>
                    <MCButton
                      onClick={() => {
                        setEditDayIndex(dayIndex);
                      }}
                      medium
                      primary
                      light
                      radius
                      style={{
                        paddingLeft: remCss(10),
                        paddingRight: remCss(5),
                        paddingVertical: remCss(5)
                      }}
                    >
                      <span>{lang.t(LANG_CONST.buttons.edit)}</span>
                      <span style={{ height: remCss(30) }}>
                        <SVGIcon
                          iconname={BASE_ICONS.DOWN}
                          width={30}
                          padding={1}
                          fill={variables['colors-mc-primary']}
                        />
                      </span>
                    </MCButton>
                  </div>
                )}
              </div>
              {invalid[id] && (
                <MCError
                  error={invalid[id]}
                  mcTextProps={{ primary: true, style: { textAlign: 'center' } }}
                />
              )}
              <div className={'mc-grow mc-flex-20-col mc-pt20 ' + (enabled ? '' : 'mc-hide')}>
                {times.map((time, timeIndex) => (
                  <View key={timeIndex} style={{ flexDirection: 'row', gap: remCss(15) }}>
                    <div
                      className={'mc-flex-20 mc-wrap mc-grow'}
                      style={{ alignItems: 'baseline' }}
                    >
                      <div className={'mc-grow'} style={{ minWidth: remCss(100) }}>
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.startTime && moment(time.startTime)}
                          onSelect={(value) =>
                            handleTimesChange(dayIndex, timeIndex, { startTime: value.valueOf() })
                          }
                        />
                        {invalid[id + '_' + timeIndex + '_time'] && (
                          <MCError
                            error={invalid[id + '_' + timeIndex + '_time']}
                            label={LANG_CONST.time}
                            mcTextProps={{ primary: true, style: { marginTop: remCss(10) } }}
                          />
                        )}
                      </div>
                      <div className={'mc-value-418'}>{lang.t('To')}</div>
                      <div className={'mc-grow'} style={{ minWidth: remCss(100) }}>
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.endTime && moment(time.endTime)}
                          onSelect={(value) =>
                            handleTimesChange(dayIndex, timeIndex, { endTime: value.valueOf() })
                          }
                        />
                      </div>

                      <div
                        className={'mc-flex'}
                        style={{
                          gap: remCss(15),
                          alignItems: 'baseline',
                          marginTop: 5
                        }}
                      >
                        <CheckboxesField
                          template={'2'}
                          list={objectToSelectList(LANG_CONST.constants.appointment_types)}
                          disabledList={
                            hospital ? [] : Object.keys(LANG_CONST.constants.appointment_types)
                          }
                          data={time.types}
                          onChange={(value) => {
                            if (!value.length) return;
                            handleTimesChange(dayIndex, timeIndex, { types: value });
                          }}
                        />

                        {/*<div style={{ width: '300px' }}>*/}
                        {/*  {time.types.includes('in_office') && (*/}
                        {/*    <HospitalSelect*/}
                        {/*      value={time.hospitalId || hospital?.hospitalId}*/}
                        {/*      placeholder={LANG_CONST.location}*/}
                        {/*      isClearable={false}*/}
                        {/*      apiConfig={hospitalParams}*/}
                        {/*      onChange={(n, v, option) => {*/}
                        {/*        handleTimesChange(dayIndex, timeIndex, {*/}
                        {/*          hospitalId: v,*/}
                        {/*          hospital: option.item.hospital,*/}
                        {/*          cityAddress: option.item.city*/}
                        {/*        });*/}
                        {/*      }}*/}
                        {/*    />*/}
                        {/*  )}*/}
                        {/*  {invalid[id + '_' + timeIndex + '_location'] && (*/}
                        {/*    <MCError*/}
                        {/*      error={invalid[id + '_' + timeIndex + '_location']}*/}
                        {/*      label={LANG_CONST.location}*/}
                        {/*      mcTextProps={{ primary: true, style: { marginTop: remCss(10) } }}*/}
                        {/*    />*/}
                        {/*  )}*/}
                        {/*</div>*/}
                      </div>
                    </div>
                    <View
                      style={{ width: remCss(50), alignItems: 'center', paddingTop: remCss(10) }}
                    >
                      {times.length > 1 ? (
                        <MCButton
                          iconname={BASE_ICONS.CLOSE}
                          secondary
                          light
                          small
                          radius
                          padding={5}
                          onClick={() => {
                            delTime(dayIndex, timeIndex);
                            setInvalid((o) => {
                              delete o[id + '_' + timeIndex + '_time'];
                              delete o[id + '_' + timeIndex + '_location'];

                              return o;
                            });
                          }}
                        />
                      ) : (
                        <MCButton
                          label={LANG_CONST.buttons.add}
                          primary
                          light
                          small
                          radius
                          style={{ marginTop: -5 }}
                          onClick={() => addTime(dayIndex)}
                        />
                      )}
                    </View>
                  </View>
                ))}
                {times.length > 1 && (
                  <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <MCButton
                      label={LANG_CONST.buttons.add}
                      primary
                      light
                      small
                      radius
                      onClick={() => addTime(dayIndex)}
                    />
                  </View>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {editDayIndex > -1 && (
        <EditDay
          hide={() => setEditDayIndex(-1)}
          day={days[editDayIndex]}
          saveTimes={(times) => handleChange(editDayIndex, 'times', times)}
        />
      )}
    </>
  );
};
